//@ts-nocheck
import { Params as Params1 } from "./params";
import { StakeEntry } from "../epochstorage/stake_entry";
import { Policy } from "../plans/policy";
import { Spec } from "../spec/spec";
import { Params as Params2 } from "../downtime/v1/downtime";
import { BinaryReader, BinaryWriter } from "../../../binary";
import { isSet } from "../../../helpers";
import { GlobalDecoderRegistry } from "../../../registry";
import { Decimal } from "@cosmjs/math";
function createBaseQueryParamsRequest() {
    return {};
}
export const QueryParamsRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryParamsRequest",
    is(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryParamsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryParamsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryParamsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryParamsRequest",
            value: QueryParamsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryParamsRequest.typeUrl, QueryParamsRequest);
function createBaseQueryParamsResponse() {
    return {
        params: Params1.fromPartial({})
    };
}
export const QueryParamsResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryParamsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params1.is(o.params));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params1.isSDK(o.params));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params1.isAmino(o.params));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.params !== undefined) {
            Params1.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = Params1.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: isSet(object.params) ? Params1.fromJSON(object.params) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? Params1.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? Params1.fromPartial(object.params) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryParamsResponse();
        if (object.params !== undefined && object.params !== null) {
            message.params = Params1.fromAmino(object.params);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.params = message.params ? Params1.toAmino(message.params) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryParamsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryParamsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryParamsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryParamsResponse",
            value: QueryParamsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryParamsResponse.typeUrl, QueryParamsResponse);
function createBaseQueryProvidersRequest() {
    return {
        chainID: "",
        showFrozen: false
    };
}
export const QueryProvidersRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryProvidersRequest",
    is(o) {
        return o && (o.$typeUrl === QueryProvidersRequest.typeUrl || typeof o.chainID === "string" && typeof o.showFrozen === "boolean");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProvidersRequest.typeUrl || typeof o.chainID === "string" && typeof o.showFrozen === "boolean");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProvidersRequest.typeUrl || typeof o.chainID === "string" && typeof o.showFrozen === "boolean");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.chainID !== "") {
            writer.uint32(10).string(message.chainID);
        }
        if (message.showFrozen === true) {
            writer.uint32(16).bool(message.showFrozen);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProvidersRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainID = reader.string();
                    break;
                case 2:
                    message.showFrozen = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainID: isSet(object.chainID) ? String(object.chainID) : "",
            showFrozen: isSet(object.showFrozen) ? Boolean(object.showFrozen) : false
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainID !== undefined && (obj.chainID = message.chainID);
        message.showFrozen !== undefined && (obj.showFrozen = message.showFrozen);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProvidersRequest();
        message.chainID = object.chainID ?? "";
        message.showFrozen = object.showFrozen ?? false;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProvidersRequest();
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        if (object.showFrozen !== undefined && object.showFrozen !== null) {
            message.showFrozen = object.showFrozen;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        obj.showFrozen = message.showFrozen === false ? undefined : message.showFrozen;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProvidersRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProvidersRequest.decode(message.value);
    },
    toProto(message) {
        return QueryProvidersRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryProvidersRequest",
            value: QueryProvidersRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProvidersRequest.typeUrl, QueryProvidersRequest);
function createBaseQueryProvidersResponse() {
    return {
        stakeEntry: []
    };
}
export const QueryProvidersResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryProvidersResponse",
    is(o) {
        return o && (o.$typeUrl === QueryProvidersResponse.typeUrl || Array.isArray(o.stakeEntry) && (!o.stakeEntry.length || StakeEntry.is(o.stakeEntry[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProvidersResponse.typeUrl || Array.isArray(o.stakeEntry) && (!o.stakeEntry.length || StakeEntry.isSDK(o.stakeEntry[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProvidersResponse.typeUrl || Array.isArray(o.stakeEntry) && (!o.stakeEntry.length || StakeEntry.isAmino(o.stakeEntry[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.stakeEntry) {
            StakeEntry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProvidersResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stakeEntry.push(StakeEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            stakeEntry: Array.isArray(object?.stakeEntry) ? object.stakeEntry.map((e) => StakeEntry.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.stakeEntry) {
            obj.stakeEntry = message.stakeEntry.map(e => e ? StakeEntry.toJSON(e) : undefined);
        }
        else {
            obj.stakeEntry = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProvidersResponse();
        message.stakeEntry = object.stakeEntry?.map(e => StakeEntry.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProvidersResponse();
        message.stakeEntry = object.stakeEntry?.map(e => StakeEntry.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.stakeEntry) {
            obj.stakeEntry = message.stakeEntry.map(e => e ? StakeEntry.toAmino(e) : undefined);
        }
        else {
            obj.stakeEntry = message.stakeEntry;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProvidersResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProvidersResponse.decode(message.value);
    },
    toProto(message) {
        return QueryProvidersResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryProvidersResponse",
            value: QueryProvidersResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProvidersResponse.typeUrl, QueryProvidersResponse);
function createBaseQueryProviderRequest() {
    return {
        address: "",
        chainID: ""
    };
}
export const QueryProviderRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryProviderRequest",
    is(o) {
        return o && (o.$typeUrl === QueryProviderRequest.typeUrl || typeof o.address === "string" && typeof o.chainID === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProviderRequest.typeUrl || typeof o.address === "string" && typeof o.chainID === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProviderRequest.typeUrl || typeof o.address === "string" && typeof o.chainID === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.chainID !== "") {
            writer.uint32(18).string(message.chainID);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProviderRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.chainID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
            chainID: isSet(object.chainID) ? String(object.chainID) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.chainID !== undefined && (obj.chainID = message.chainID);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProviderRequest();
        message.address = object.address ?? "";
        message.chainID = object.chainID ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProviderRequest();
        if (object.address !== undefined && object.address !== null) {
            message.address = object.address;
        }
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.address = message.address === "" ? undefined : message.address;
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProviderRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProviderRequest.decode(message.value);
    },
    toProto(message) {
        return QueryProviderRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryProviderRequest",
            value: QueryProviderRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProviderRequest.typeUrl, QueryProviderRequest);
function createBaseQueryProviderResponse() {
    return {
        stakeEntries: []
    };
}
export const QueryProviderResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryProviderResponse",
    is(o) {
        return o && (o.$typeUrl === QueryProviderResponse.typeUrl || Array.isArray(o.stakeEntries) && (!o.stakeEntries.length || StakeEntry.is(o.stakeEntries[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProviderResponse.typeUrl || Array.isArray(o.stakeEntries) && (!o.stakeEntries.length || StakeEntry.isSDK(o.stakeEntries[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProviderResponse.typeUrl || Array.isArray(o.stakeEntries) && (!o.stakeEntries.length || StakeEntry.isAmino(o.stakeEntries[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.stakeEntries) {
            StakeEntry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProviderResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stakeEntries.push(StakeEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            stakeEntries: Array.isArray(object?.stakeEntries) ? object.stakeEntries.map((e) => StakeEntry.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.stakeEntries) {
            obj.stakeEntries = message.stakeEntries.map(e => e ? StakeEntry.toJSON(e) : undefined);
        }
        else {
            obj.stakeEntries = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProviderResponse();
        message.stakeEntries = object.stakeEntries?.map(e => StakeEntry.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProviderResponse();
        message.stakeEntries = object.stakeEntries?.map(e => StakeEntry.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.stakeEntries) {
            obj.stakeEntries = message.stakeEntries.map(e => e ? StakeEntry.toAmino(e) : undefined);
        }
        else {
            obj.stakeEntries = message.stakeEntries;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProviderResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProviderResponse.decode(message.value);
    },
    toProto(message) {
        return QueryProviderResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryProviderResponse",
            value: QueryProviderResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProviderResponse.typeUrl, QueryProviderResponse);
function createBaseQueryGetPairingRequest() {
    return {
        chainID: "",
        client: ""
    };
}
export const QueryGetPairingRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryGetPairingRequest",
    is(o) {
        return o && (o.$typeUrl === QueryGetPairingRequest.typeUrl || typeof o.chainID === "string" && typeof o.client === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryGetPairingRequest.typeUrl || typeof o.chainID === "string" && typeof o.client === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryGetPairingRequest.typeUrl || typeof o.chainID === "string" && typeof o.client === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.chainID !== "") {
            writer.uint32(10).string(message.chainID);
        }
        if (message.client !== "") {
            writer.uint32(18).string(message.client);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGetPairingRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainID = reader.string();
                    break;
                case 2:
                    message.client = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainID: isSet(object.chainID) ? String(object.chainID) : "",
            client: isSet(object.client) ? String(object.client) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainID !== undefined && (obj.chainID = message.chainID);
        message.client !== undefined && (obj.client = message.client);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGetPairingRequest();
        message.chainID = object.chainID ?? "";
        message.client = object.client ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryGetPairingRequest();
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        if (object.client !== undefined && object.client !== null) {
            message.client = object.client;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        obj.client = message.client === "" ? undefined : message.client;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryGetPairingRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryGetPairingRequest.decode(message.value);
    },
    toProto(message) {
        return QueryGetPairingRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryGetPairingRequest",
            value: QueryGetPairingRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryGetPairingRequest.typeUrl, QueryGetPairingRequest);
function createBaseQueryGetPairingResponse() {
    return {
        providers: [],
        currentEpoch: BigInt(0),
        timeLeftToNextPairing: BigInt(0),
        specLastUpdatedBlock: BigInt(0),
        blockOfNextPairing: BigInt(0)
    };
}
export const QueryGetPairingResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryGetPairingResponse",
    is(o) {
        return o && (o.$typeUrl === QueryGetPairingResponse.typeUrl || Array.isArray(o.providers) && (!o.providers.length || StakeEntry.is(o.providers[0])) && typeof o.currentEpoch === "bigint" && typeof o.timeLeftToNextPairing === "bigint" && typeof o.specLastUpdatedBlock === "bigint" && typeof o.blockOfNextPairing === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryGetPairingResponse.typeUrl || Array.isArray(o.providers) && (!o.providers.length || StakeEntry.isSDK(o.providers[0])) && typeof o.current_epoch === "bigint" && typeof o.time_left_to_next_pairing === "bigint" && typeof o.spec_last_updated_block === "bigint" && typeof o.block_of_next_pairing === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryGetPairingResponse.typeUrl || Array.isArray(o.providers) && (!o.providers.length || StakeEntry.isAmino(o.providers[0])) && typeof o.current_epoch === "bigint" && typeof o.time_left_to_next_pairing === "bigint" && typeof o.spec_last_updated_block === "bigint" && typeof o.block_of_next_pairing === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.providers) {
            StakeEntry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.currentEpoch !== BigInt(0)) {
            writer.uint32(16).uint64(message.currentEpoch);
        }
        if (message.timeLeftToNextPairing !== BigInt(0)) {
            writer.uint32(24).uint64(message.timeLeftToNextPairing);
        }
        if (message.specLastUpdatedBlock !== BigInt(0)) {
            writer.uint32(32).uint64(message.specLastUpdatedBlock);
        }
        if (message.blockOfNextPairing !== BigInt(0)) {
            writer.uint32(40).uint64(message.blockOfNextPairing);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGetPairingResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.providers.push(StakeEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.currentEpoch = reader.uint64();
                    break;
                case 3:
                    message.timeLeftToNextPairing = reader.uint64();
                    break;
                case 4:
                    message.specLastUpdatedBlock = reader.uint64();
                    break;
                case 5:
                    message.blockOfNextPairing = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            providers: Array.isArray(object?.providers) ? object.providers.map((e) => StakeEntry.fromJSON(e)) : [],
            currentEpoch: isSet(object.currentEpoch) ? BigInt(object.currentEpoch.toString()) : BigInt(0),
            timeLeftToNextPairing: isSet(object.timeLeftToNextPairing) ? BigInt(object.timeLeftToNextPairing.toString()) : BigInt(0),
            specLastUpdatedBlock: isSet(object.specLastUpdatedBlock) ? BigInt(object.specLastUpdatedBlock.toString()) : BigInt(0),
            blockOfNextPairing: isSet(object.blockOfNextPairing) ? BigInt(object.blockOfNextPairing.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.providers) {
            obj.providers = message.providers.map(e => e ? StakeEntry.toJSON(e) : undefined);
        }
        else {
            obj.providers = [];
        }
        message.currentEpoch !== undefined && (obj.currentEpoch = (message.currentEpoch || BigInt(0)).toString());
        message.timeLeftToNextPairing !== undefined && (obj.timeLeftToNextPairing = (message.timeLeftToNextPairing || BigInt(0)).toString());
        message.specLastUpdatedBlock !== undefined && (obj.specLastUpdatedBlock = (message.specLastUpdatedBlock || BigInt(0)).toString());
        message.blockOfNextPairing !== undefined && (obj.blockOfNextPairing = (message.blockOfNextPairing || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGetPairingResponse();
        message.providers = object.providers?.map(e => StakeEntry.fromPartial(e)) || [];
        message.currentEpoch = object.currentEpoch !== undefined && object.currentEpoch !== null ? BigInt(object.currentEpoch.toString()) : BigInt(0);
        message.timeLeftToNextPairing = object.timeLeftToNextPairing !== undefined && object.timeLeftToNextPairing !== null ? BigInt(object.timeLeftToNextPairing.toString()) : BigInt(0);
        message.specLastUpdatedBlock = object.specLastUpdatedBlock !== undefined && object.specLastUpdatedBlock !== null ? BigInt(object.specLastUpdatedBlock.toString()) : BigInt(0);
        message.blockOfNextPairing = object.blockOfNextPairing !== undefined && object.blockOfNextPairing !== null ? BigInt(object.blockOfNextPairing.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryGetPairingResponse();
        message.providers = object.providers?.map(e => StakeEntry.fromAmino(e)) || [];
        if (object.current_epoch !== undefined && object.current_epoch !== null) {
            message.currentEpoch = BigInt(object.current_epoch);
        }
        if (object.time_left_to_next_pairing !== undefined && object.time_left_to_next_pairing !== null) {
            message.timeLeftToNextPairing = BigInt(object.time_left_to_next_pairing);
        }
        if (object.spec_last_updated_block !== undefined && object.spec_last_updated_block !== null) {
            message.specLastUpdatedBlock = BigInt(object.spec_last_updated_block);
        }
        if (object.block_of_next_pairing !== undefined && object.block_of_next_pairing !== null) {
            message.blockOfNextPairing = BigInt(object.block_of_next_pairing);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.providers) {
            obj.providers = message.providers.map(e => e ? StakeEntry.toAmino(e) : undefined);
        }
        else {
            obj.providers = message.providers;
        }
        obj.current_epoch = message.currentEpoch !== BigInt(0) ? (message.currentEpoch?.toString)() : undefined;
        obj.time_left_to_next_pairing = message.timeLeftToNextPairing !== BigInt(0) ? (message.timeLeftToNextPairing?.toString)() : undefined;
        obj.spec_last_updated_block = message.specLastUpdatedBlock !== BigInt(0) ? (message.specLastUpdatedBlock?.toString)() : undefined;
        obj.block_of_next_pairing = message.blockOfNextPairing !== BigInt(0) ? (message.blockOfNextPairing?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryGetPairingResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryGetPairingResponse.decode(message.value);
    },
    toProto(message) {
        return QueryGetPairingResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryGetPairingResponse",
            value: QueryGetPairingResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryGetPairingResponse.typeUrl, QueryGetPairingResponse);
function createBaseQueryVerifyPairingRequest() {
    return {
        chainID: "",
        client: "",
        provider: "",
        block: BigInt(0)
    };
}
export const QueryVerifyPairingRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryVerifyPairingRequest",
    is(o) {
        return o && (o.$typeUrl === QueryVerifyPairingRequest.typeUrl || typeof o.chainID === "string" && typeof o.client === "string" && typeof o.provider === "string" && typeof o.block === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryVerifyPairingRequest.typeUrl || typeof o.chainID === "string" && typeof o.client === "string" && typeof o.provider === "string" && typeof o.block === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryVerifyPairingRequest.typeUrl || typeof o.chainID === "string" && typeof o.client === "string" && typeof o.provider === "string" && typeof o.block === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.chainID !== "") {
            writer.uint32(10).string(message.chainID);
        }
        if (message.client !== "") {
            writer.uint32(18).string(message.client);
        }
        if (message.provider !== "") {
            writer.uint32(26).string(message.provider);
        }
        if (message.block !== BigInt(0)) {
            writer.uint32(32).uint64(message.block);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVerifyPairingRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainID = reader.string();
                    break;
                case 2:
                    message.client = reader.string();
                    break;
                case 3:
                    message.provider = reader.string();
                    break;
                case 4:
                    message.block = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainID: isSet(object.chainID) ? String(object.chainID) : "",
            client: isSet(object.client) ? String(object.client) : "",
            provider: isSet(object.provider) ? String(object.provider) : "",
            block: isSet(object.block) ? BigInt(object.block.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainID !== undefined && (obj.chainID = message.chainID);
        message.client !== undefined && (obj.client = message.client);
        message.provider !== undefined && (obj.provider = message.provider);
        message.block !== undefined && (obj.block = (message.block || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVerifyPairingRequest();
        message.chainID = object.chainID ?? "";
        message.client = object.client ?? "";
        message.provider = object.provider ?? "";
        message.block = object.block !== undefined && object.block !== null ? BigInt(object.block.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryVerifyPairingRequest();
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        if (object.client !== undefined && object.client !== null) {
            message.client = object.client;
        }
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        if (object.block !== undefined && object.block !== null) {
            message.block = BigInt(object.block);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        obj.client = message.client === "" ? undefined : message.client;
        obj.provider = message.provider === "" ? undefined : message.provider;
        obj.block = message.block !== BigInt(0) ? (message.block?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryVerifyPairingRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryVerifyPairingRequest.decode(message.value);
    },
    toProto(message) {
        return QueryVerifyPairingRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryVerifyPairingRequest",
            value: QueryVerifyPairingRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryVerifyPairingRequest.typeUrl, QueryVerifyPairingRequest);
function createBaseQueryVerifyPairingResponse() {
    return {
        valid: false,
        pairedProviders: BigInt(0),
        cuPerEpoch: BigInt(0),
        projectId: ""
    };
}
export const QueryVerifyPairingResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryVerifyPairingResponse",
    is(o) {
        return o && (o.$typeUrl === QueryVerifyPairingResponse.typeUrl || typeof o.valid === "boolean" && typeof o.pairedProviders === "bigint" && typeof o.cuPerEpoch === "bigint" && typeof o.projectId === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryVerifyPairingResponse.typeUrl || typeof o.valid === "boolean" && typeof o.paired_providers === "bigint" && typeof o.cu_per_epoch === "bigint" && typeof o.project_id === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryVerifyPairingResponse.typeUrl || typeof o.valid === "boolean" && typeof o.paired_providers === "bigint" && typeof o.cu_per_epoch === "bigint" && typeof o.project_id === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.valid === true) {
            writer.uint32(8).bool(message.valid);
        }
        if (message.pairedProviders !== BigInt(0)) {
            writer.uint32(24).uint64(message.pairedProviders);
        }
        if (message.cuPerEpoch !== BigInt(0)) {
            writer.uint32(32).uint64(message.cuPerEpoch);
        }
        if (message.projectId !== "") {
            writer.uint32(42).string(message.projectId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryVerifyPairingResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.valid = reader.bool();
                    break;
                case 3:
                    message.pairedProviders = reader.uint64();
                    break;
                case 4:
                    message.cuPerEpoch = reader.uint64();
                    break;
                case 5:
                    message.projectId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            valid: isSet(object.valid) ? Boolean(object.valid) : false,
            pairedProviders: isSet(object.pairedProviders) ? BigInt(object.pairedProviders.toString()) : BigInt(0),
            cuPerEpoch: isSet(object.cuPerEpoch) ? BigInt(object.cuPerEpoch.toString()) : BigInt(0),
            projectId: isSet(object.projectId) ? String(object.projectId) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.valid !== undefined && (obj.valid = message.valid);
        message.pairedProviders !== undefined && (obj.pairedProviders = (message.pairedProviders || BigInt(0)).toString());
        message.cuPerEpoch !== undefined && (obj.cuPerEpoch = (message.cuPerEpoch || BigInt(0)).toString());
        message.projectId !== undefined && (obj.projectId = message.projectId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryVerifyPairingResponse();
        message.valid = object.valid ?? false;
        message.pairedProviders = object.pairedProviders !== undefined && object.pairedProviders !== null ? BigInt(object.pairedProviders.toString()) : BigInt(0);
        message.cuPerEpoch = object.cuPerEpoch !== undefined && object.cuPerEpoch !== null ? BigInt(object.cuPerEpoch.toString()) : BigInt(0);
        message.projectId = object.projectId ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryVerifyPairingResponse();
        if (object.valid !== undefined && object.valid !== null) {
            message.valid = object.valid;
        }
        if (object.paired_providers !== undefined && object.paired_providers !== null) {
            message.pairedProviders = BigInt(object.paired_providers);
        }
        if (object.cu_per_epoch !== undefined && object.cu_per_epoch !== null) {
            message.cuPerEpoch = BigInt(object.cu_per_epoch);
        }
        if (object.project_id !== undefined && object.project_id !== null) {
            message.projectId = object.project_id;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.valid = message.valid === false ? undefined : message.valid;
        obj.paired_providers = message.pairedProviders !== BigInt(0) ? (message.pairedProviders?.toString)() : undefined;
        obj.cu_per_epoch = message.cuPerEpoch !== BigInt(0) ? (message.cuPerEpoch?.toString)() : undefined;
        obj.project_id = message.projectId === "" ? undefined : message.projectId;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryVerifyPairingResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryVerifyPairingResponse.decode(message.value);
    },
    toProto(message) {
        return QueryVerifyPairingResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryVerifyPairingResponse",
            value: QueryVerifyPairingResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryVerifyPairingResponse.typeUrl, QueryVerifyPairingResponse);
function createBaseQueryProviderPairingChanceRequest() {
    return {
        provider: "",
        chainID: "",
        geolocation: 0,
        cluster: ""
    };
}
export const QueryProviderPairingChanceRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryProviderPairingChanceRequest",
    is(o) {
        return o && (o.$typeUrl === QueryProviderPairingChanceRequest.typeUrl || typeof o.provider === "string" && typeof o.chainID === "string" && typeof o.geolocation === "number" && typeof o.cluster === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProviderPairingChanceRequest.typeUrl || typeof o.provider === "string" && typeof o.chainID === "string" && typeof o.geolocation === "number" && typeof o.cluster === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProviderPairingChanceRequest.typeUrl || typeof o.provider === "string" && typeof o.chainID === "string" && typeof o.geolocation === "number" && typeof o.cluster === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.provider !== "") {
            writer.uint32(10).string(message.provider);
        }
        if (message.chainID !== "") {
            writer.uint32(18).string(message.chainID);
        }
        if (message.geolocation !== 0) {
            writer.uint32(24).int32(message.geolocation);
        }
        if (message.cluster !== "") {
            writer.uint32(34).string(message.cluster);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProviderPairingChanceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.provider = reader.string();
                    break;
                case 2:
                    message.chainID = reader.string();
                    break;
                case 3:
                    message.geolocation = reader.int32();
                    break;
                case 4:
                    message.cluster = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            provider: isSet(object.provider) ? String(object.provider) : "",
            chainID: isSet(object.chainID) ? String(object.chainID) : "",
            geolocation: isSet(object.geolocation) ? Number(object.geolocation) : 0,
            cluster: isSet(object.cluster) ? String(object.cluster) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.provider !== undefined && (obj.provider = message.provider);
        message.chainID !== undefined && (obj.chainID = message.chainID);
        message.geolocation !== undefined && (obj.geolocation = Math.round(message.geolocation));
        message.cluster !== undefined && (obj.cluster = message.cluster);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProviderPairingChanceRequest();
        message.provider = object.provider ?? "";
        message.chainID = object.chainID ?? "";
        message.geolocation = object.geolocation ?? 0;
        message.cluster = object.cluster ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProviderPairingChanceRequest();
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        if (object.geolocation !== undefined && object.geolocation !== null) {
            message.geolocation = object.geolocation;
        }
        if (object.cluster !== undefined && object.cluster !== null) {
            message.cluster = object.cluster;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.provider = message.provider === "" ? undefined : message.provider;
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        obj.geolocation = message.geolocation === 0 ? undefined : message.geolocation;
        obj.cluster = message.cluster === "" ? undefined : message.cluster;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProviderPairingChanceRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProviderPairingChanceRequest.decode(message.value);
    },
    toProto(message) {
        return QueryProviderPairingChanceRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryProviderPairingChanceRequest",
            value: QueryProviderPairingChanceRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProviderPairingChanceRequest.typeUrl, QueryProviderPairingChanceRequest);
function createBaseQueryProviderPairingChanceResponse() {
    return {
        chance: ""
    };
}
export const QueryProviderPairingChanceResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryProviderPairingChanceResponse",
    is(o) {
        return o && (o.$typeUrl === QueryProviderPairingChanceResponse.typeUrl || typeof o.chance === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProviderPairingChanceResponse.typeUrl || typeof o.chance === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProviderPairingChanceResponse.typeUrl || typeof o.chance === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.chance !== "") {
            writer.uint32(10).string(Decimal.fromUserInput(message.chance, 18).atomics);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProviderPairingChanceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chance = Decimal.fromAtomics(reader.string(), 18).toString();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chance: isSet(object.chance) ? String(object.chance) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.chance !== undefined && (obj.chance = message.chance);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProviderPairingChanceResponse();
        message.chance = object.chance ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProviderPairingChanceResponse();
        if (object.chance !== undefined && object.chance !== null) {
            message.chance = object.chance;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.chance = message.chance === "" ? undefined : message.chance;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProviderPairingChanceResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProviderPairingChanceResponse.decode(message.value);
    },
    toProto(message) {
        return QueryProviderPairingChanceResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryProviderPairingChanceResponse",
            value: QueryProviderPairingChanceResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProviderPairingChanceResponse.typeUrl, QueryProviderPairingChanceResponse);
function createBaseQueryUserEntryRequest() {
    return {
        address: "",
        chainID: "",
        block: BigInt(0)
    };
}
export const QueryUserEntryRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryUserEntryRequest",
    is(o) {
        return o && (o.$typeUrl === QueryUserEntryRequest.typeUrl || typeof o.address === "string" && typeof o.chainID === "string" && typeof o.block === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryUserEntryRequest.typeUrl || typeof o.address === "string" && typeof o.chainID === "string" && typeof o.block === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryUserEntryRequest.typeUrl || typeof o.address === "string" && typeof o.chainID === "string" && typeof o.block === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.chainID !== "") {
            writer.uint32(18).string(message.chainID);
        }
        if (message.block !== BigInt(0)) {
            writer.uint32(24).uint64(message.block);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUserEntryRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.chainID = reader.string();
                    break;
                case 3:
                    message.block = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            address: isSet(object.address) ? String(object.address) : "",
            chainID: isSet(object.chainID) ? String(object.chainID) : "",
            block: isSet(object.block) ? BigInt(object.block.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.chainID !== undefined && (obj.chainID = message.chainID);
        message.block !== undefined && (obj.block = (message.block || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUserEntryRequest();
        message.address = object.address ?? "";
        message.chainID = object.chainID ?? "";
        message.block = object.block !== undefined && object.block !== null ? BigInt(object.block.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryUserEntryRequest();
        if (object.address !== undefined && object.address !== null) {
            message.address = object.address;
        }
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        if (object.block !== undefined && object.block !== null) {
            message.block = BigInt(object.block);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.address = message.address === "" ? undefined : message.address;
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        obj.block = message.block !== BigInt(0) ? (message.block?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryUserEntryRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryUserEntryRequest.decode(message.value);
    },
    toProto(message) {
        return QueryUserEntryRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryUserEntryRequest",
            value: QueryUserEntryRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryUserEntryRequest.typeUrl, QueryUserEntryRequest);
function createBaseQueryUserEntryResponse() {
    return {
        consumer: StakeEntry.fromPartial({}),
        maxCU: BigInt(0)
    };
}
export const QueryUserEntryResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryUserEntryResponse",
    is(o) {
        return o && (o.$typeUrl === QueryUserEntryResponse.typeUrl || StakeEntry.is(o.consumer) && typeof o.maxCU === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryUserEntryResponse.typeUrl || StakeEntry.isSDK(o.consumer) && typeof o.maxCU === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryUserEntryResponse.typeUrl || StakeEntry.isAmino(o.consumer) && typeof o.maxCU === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.consumer !== undefined) {
            StakeEntry.encode(message.consumer, writer.uint32(10).fork()).ldelim();
        }
        if (message.maxCU !== BigInt(0)) {
            writer.uint32(16).uint64(message.maxCU);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUserEntryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consumer = StakeEntry.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxCU = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consumer: isSet(object.consumer) ? StakeEntry.fromJSON(object.consumer) : undefined,
            maxCU: isSet(object.maxCU) ? BigInt(object.maxCU.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.consumer !== undefined && (obj.consumer = message.consumer ? StakeEntry.toJSON(message.consumer) : undefined);
        message.maxCU !== undefined && (obj.maxCU = (message.maxCU || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUserEntryResponse();
        message.consumer = object.consumer !== undefined && object.consumer !== null ? StakeEntry.fromPartial(object.consumer) : undefined;
        message.maxCU = object.maxCU !== undefined && object.maxCU !== null ? BigInt(object.maxCU.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryUserEntryResponse();
        if (object.consumer !== undefined && object.consumer !== null) {
            message.consumer = StakeEntry.fromAmino(object.consumer);
        }
        if (object.maxCU !== undefined && object.maxCU !== null) {
            message.maxCU = BigInt(object.maxCU);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.consumer = message.consumer ? StakeEntry.toAmino(message.consumer) : undefined;
        obj.maxCU = message.maxCU !== BigInt(0) ? (message.maxCU?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryUserEntryResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryUserEntryResponse.decode(message.value);
    },
    toProto(message) {
        return QueryUserEntryResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryUserEntryResponse",
            value: QueryUserEntryResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryUserEntryResponse.typeUrl, QueryUserEntryResponse);
function createBaseQueryStaticProvidersListRequest() {
    return {
        chainID: ""
    };
}
export const QueryStaticProvidersListRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryStaticProvidersListRequest",
    is(o) {
        return o && (o.$typeUrl === QueryStaticProvidersListRequest.typeUrl || typeof o.chainID === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryStaticProvidersListRequest.typeUrl || typeof o.chainID === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryStaticProvidersListRequest.typeUrl || typeof o.chainID === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.chainID !== "") {
            writer.uint32(10).string(message.chainID);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryStaticProvidersListRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainID: isSet(object.chainID) ? String(object.chainID) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainID !== undefined && (obj.chainID = message.chainID);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryStaticProvidersListRequest();
        message.chainID = object.chainID ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryStaticProvidersListRequest();
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryStaticProvidersListRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryStaticProvidersListRequest.decode(message.value);
    },
    toProto(message) {
        return QueryStaticProvidersListRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryStaticProvidersListRequest",
            value: QueryStaticProvidersListRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryStaticProvidersListRequest.typeUrl, QueryStaticProvidersListRequest);
function createBaseQueryStaticProvidersListResponse() {
    return {
        providers: []
    };
}
export const QueryStaticProvidersListResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryStaticProvidersListResponse",
    is(o) {
        return o && (o.$typeUrl === QueryStaticProvidersListResponse.typeUrl || Array.isArray(o.providers) && (!o.providers.length || StakeEntry.is(o.providers[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryStaticProvidersListResponse.typeUrl || Array.isArray(o.providers) && (!o.providers.length || StakeEntry.isSDK(o.providers[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryStaticProvidersListResponse.typeUrl || Array.isArray(o.providers) && (!o.providers.length || StakeEntry.isAmino(o.providers[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.providers) {
            StakeEntry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryStaticProvidersListResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.providers.push(StakeEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            providers: Array.isArray(object?.providers) ? object.providers.map((e) => StakeEntry.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.providers) {
            obj.providers = message.providers.map(e => e ? StakeEntry.toJSON(e) : undefined);
        }
        else {
            obj.providers = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryStaticProvidersListResponse();
        message.providers = object.providers?.map(e => StakeEntry.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryStaticProvidersListResponse();
        message.providers = object.providers?.map(e => StakeEntry.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.providers) {
            obj.providers = message.providers.map(e => e ? StakeEntry.toAmino(e) : undefined);
        }
        else {
            obj.providers = message.providers;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryStaticProvidersListResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryStaticProvidersListResponse.decode(message.value);
    },
    toProto(message) {
        return QueryStaticProvidersListResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryStaticProvidersListResponse",
            value: QueryStaticProvidersListResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryStaticProvidersListResponse.typeUrl, QueryStaticProvidersListResponse);
function createBaseQueryEffectivePolicyRequest() {
    return {
        consumer: "",
        specID: ""
    };
}
export const QueryEffectivePolicyRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryEffectivePolicyRequest",
    is(o) {
        return o && (o.$typeUrl === QueryEffectivePolicyRequest.typeUrl || typeof o.consumer === "string" && typeof o.specID === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryEffectivePolicyRequest.typeUrl || typeof o.consumer === "string" && typeof o.specID === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryEffectivePolicyRequest.typeUrl || typeof o.consumer === "string" && typeof o.specID === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.consumer !== "") {
            writer.uint32(10).string(message.consumer);
        }
        if (message.specID !== "") {
            writer.uint32(18).string(message.specID);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEffectivePolicyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consumer = reader.string();
                    break;
                case 2:
                    message.specID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consumer: isSet(object.consumer) ? String(object.consumer) : "",
            specID: isSet(object.specID) ? String(object.specID) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.consumer !== undefined && (obj.consumer = message.consumer);
        message.specID !== undefined && (obj.specID = message.specID);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEffectivePolicyRequest();
        message.consumer = object.consumer ?? "";
        message.specID = object.specID ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryEffectivePolicyRequest();
        if (object.consumer !== undefined && object.consumer !== null) {
            message.consumer = object.consumer;
        }
        if (object.specID !== undefined && object.specID !== null) {
            message.specID = object.specID;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.consumer = message.consumer === "" ? undefined : message.consumer;
        obj.specID = message.specID === "" ? undefined : message.specID;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryEffectivePolicyRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryEffectivePolicyRequest.decode(message.value);
    },
    toProto(message) {
        return QueryEffectivePolicyRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryEffectivePolicyRequest",
            value: QueryEffectivePolicyRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryEffectivePolicyRequest.typeUrl, QueryEffectivePolicyRequest);
function createBaseQueryEffectivePolicyResponse() {
    return {
        policy: undefined,
        pendingPolicy: undefined
    };
}
export const QueryEffectivePolicyResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryEffectivePolicyResponse",
    is(o) {
        return o && o.$typeUrl === QueryEffectivePolicyResponse.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryEffectivePolicyResponse.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryEffectivePolicyResponse.typeUrl;
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.policy !== undefined) {
            Policy.encode(message.policy, writer.uint32(10).fork()).ldelim();
        }
        if (message.pendingPolicy !== undefined) {
            Policy.encode(message.pendingPolicy, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEffectivePolicyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.policy = Policy.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.pendingPolicy = Policy.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            policy: isSet(object.policy) ? Policy.fromJSON(object.policy) : undefined,
            pendingPolicy: isSet(object.pendingPolicy) ? Policy.fromJSON(object.pendingPolicy) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.policy !== undefined && (obj.policy = message.policy ? Policy.toJSON(message.policy) : undefined);
        message.pendingPolicy !== undefined && (obj.pendingPolicy = message.pendingPolicy ? Policy.toJSON(message.pendingPolicy) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEffectivePolicyResponse();
        message.policy = object.policy !== undefined && object.policy !== null ? Policy.fromPartial(object.policy) : undefined;
        message.pendingPolicy = object.pendingPolicy !== undefined && object.pendingPolicy !== null ? Policy.fromPartial(object.pendingPolicy) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryEffectivePolicyResponse();
        if (object.policy !== undefined && object.policy !== null) {
            message.policy = Policy.fromAmino(object.policy);
        }
        if (object.pending_policy !== undefined && object.pending_policy !== null) {
            message.pendingPolicy = Policy.fromAmino(object.pending_policy);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.policy = message.policy ? Policy.toAmino(message.policy) : undefined;
        obj.pending_policy = message.pendingPolicy ? Policy.toAmino(message.pendingPolicy) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryEffectivePolicyResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryEffectivePolicyResponse.decode(message.value);
    },
    toProto(message) {
        return QueryEffectivePolicyResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryEffectivePolicyResponse",
            value: QueryEffectivePolicyResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryEffectivePolicyResponse.typeUrl, QueryEffectivePolicyResponse);
function createBaseQuerySdkPairingResponse() {
    return {
        pairing: undefined,
        maxCu: BigInt(0),
        spec: undefined,
        downtimeParams: undefined
    };
}
export const QuerySdkPairingResponse = {
    typeUrl: "/lavanet.lava.pairing.QuerySdkPairingResponse",
    is(o) {
        return o && (o.$typeUrl === QuerySdkPairingResponse.typeUrl || typeof o.maxCu === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QuerySdkPairingResponse.typeUrl || typeof o.max_cu === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QuerySdkPairingResponse.typeUrl || typeof o.max_cu === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.pairing !== undefined) {
            QueryGetPairingResponse.encode(message.pairing, writer.uint32(10).fork()).ldelim();
        }
        if (message.maxCu !== BigInt(0)) {
            writer.uint32(16).uint64(message.maxCu);
        }
        if (message.spec !== undefined) {
            Spec.encode(message.spec, writer.uint32(26).fork()).ldelim();
        }
        if (message.downtimeParams !== undefined) {
            Params2.encode(message.downtimeParams, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySdkPairingResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pairing = QueryGetPairingResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxCu = reader.uint64();
                    break;
                case 3:
                    message.spec = Spec.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.downtimeParams = Params2.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pairing: isSet(object.pairing) ? QueryGetPairingResponse.fromJSON(object.pairing) : undefined,
            maxCu: isSet(object.maxCu) ? BigInt(object.maxCu.toString()) : BigInt(0),
            spec: isSet(object.spec) ? Spec.fromJSON(object.spec) : undefined,
            downtimeParams: isSet(object.downtimeParams) ? Params2.fromJSON(object.downtimeParams) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.pairing !== undefined && (obj.pairing = message.pairing ? QueryGetPairingResponse.toJSON(message.pairing) : undefined);
        message.maxCu !== undefined && (obj.maxCu = (message.maxCu || BigInt(0)).toString());
        message.spec !== undefined && (obj.spec = message.spec ? Spec.toJSON(message.spec) : undefined);
        message.downtimeParams !== undefined && (obj.downtimeParams = message.downtimeParams ? Params2.toJSON(message.downtimeParams) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySdkPairingResponse();
        message.pairing = object.pairing !== undefined && object.pairing !== null ? QueryGetPairingResponse.fromPartial(object.pairing) : undefined;
        message.maxCu = object.maxCu !== undefined && object.maxCu !== null ? BigInt(object.maxCu.toString()) : BigInt(0);
        message.spec = object.spec !== undefined && object.spec !== null ? Spec.fromPartial(object.spec) : undefined;
        message.downtimeParams = object.downtimeParams !== undefined && object.downtimeParams !== null ? Params2.fromPartial(object.downtimeParams) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQuerySdkPairingResponse();
        if (object.pairing !== undefined && object.pairing !== null) {
            message.pairing = QueryGetPairingResponse.fromAmino(object.pairing);
        }
        if (object.max_cu !== undefined && object.max_cu !== null) {
            message.maxCu = BigInt(object.max_cu);
        }
        if (object.spec !== undefined && object.spec !== null) {
            message.spec = Spec.fromAmino(object.spec);
        }
        if (object.downtime_params !== undefined && object.downtime_params !== null) {
            message.downtimeParams = Params2.fromAmino(object.downtime_params);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.pairing = message.pairing ? QueryGetPairingResponse.toAmino(message.pairing) : undefined;
        obj.max_cu = message.maxCu !== BigInt(0) ? (message.maxCu?.toString)() : undefined;
        obj.spec = message.spec ? Spec.toAmino(message.spec) : undefined;
        obj.downtime_params = message.downtimeParams ? Params2.toAmino(message.downtimeParams) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QuerySdkPairingResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QuerySdkPairingResponse.decode(message.value);
    },
    toProto(message) {
        return QuerySdkPairingResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QuerySdkPairingResponse",
            value: QuerySdkPairingResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QuerySdkPairingResponse.typeUrl, QuerySdkPairingResponse);
function createBaseQueryProviderMonthlyPayoutRequest() {
    return {
        provider: ""
    };
}
export const QueryProviderMonthlyPayoutRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryProviderMonthlyPayoutRequest",
    is(o) {
        return o && (o.$typeUrl === QueryProviderMonthlyPayoutRequest.typeUrl || typeof o.provider === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProviderMonthlyPayoutRequest.typeUrl || typeof o.provider === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProviderMonthlyPayoutRequest.typeUrl || typeof o.provider === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.provider !== "") {
            writer.uint32(10).string(message.provider);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProviderMonthlyPayoutRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.provider = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            provider: isSet(object.provider) ? String(object.provider) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.provider !== undefined && (obj.provider = message.provider);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProviderMonthlyPayoutRequest();
        message.provider = object.provider ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProviderMonthlyPayoutRequest();
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.provider = message.provider === "" ? undefined : message.provider;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProviderMonthlyPayoutRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProviderMonthlyPayoutRequest.decode(message.value);
    },
    toProto(message) {
        return QueryProviderMonthlyPayoutRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryProviderMonthlyPayoutRequest",
            value: QueryProviderMonthlyPayoutRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProviderMonthlyPayoutRequest.typeUrl, QueryProviderMonthlyPayoutRequest);
function createBaseSubscriptionPayout() {
    return {
        subscription: "",
        chainId: "",
        amount: BigInt(0)
    };
}
export const SubscriptionPayout = {
    typeUrl: "/lavanet.lava.pairing.SubscriptionPayout",
    is(o) {
        return o && (o.$typeUrl === SubscriptionPayout.typeUrl || typeof o.subscription === "string" && typeof o.chainId === "string" && typeof o.amount === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === SubscriptionPayout.typeUrl || typeof o.subscription === "string" && typeof o.chain_id === "string" && typeof o.amount === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === SubscriptionPayout.typeUrl || typeof o.subscription === "string" && typeof o.chain_id === "string" && typeof o.amount === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.subscription !== "") {
            writer.uint32(10).string(message.subscription);
        }
        if (message.chainId !== "") {
            writer.uint32(18).string(message.chainId);
        }
        if (message.amount !== BigInt(0)) {
            writer.uint32(24).uint64(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubscriptionPayout();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subscription = reader.string();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.amount = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            subscription: isSet(object.subscription) ? String(object.subscription) : "",
            chainId: isSet(object.chainId) ? String(object.chainId) : "",
            amount: isSet(object.amount) ? BigInt(object.amount.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.subscription !== undefined && (obj.subscription = message.subscription);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.amount !== undefined && (obj.amount = (message.amount || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseSubscriptionPayout();
        message.subscription = object.subscription ?? "";
        message.chainId = object.chainId ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? BigInt(object.amount.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseSubscriptionPayout();
        if (object.subscription !== undefined && object.subscription !== null) {
            message.subscription = object.subscription;
        }
        if (object.chain_id !== undefined && object.chain_id !== null) {
            message.chainId = object.chain_id;
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = BigInt(object.amount);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.subscription = message.subscription === "" ? undefined : message.subscription;
        obj.chain_id = message.chainId === "" ? undefined : message.chainId;
        obj.amount = message.amount !== BigInt(0) ? (message.amount?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return SubscriptionPayout.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return SubscriptionPayout.decode(message.value);
    },
    toProto(message) {
        return SubscriptionPayout.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.SubscriptionPayout",
            value: SubscriptionPayout.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(SubscriptionPayout.typeUrl, SubscriptionPayout);
function createBaseQueryProviderMonthlyPayoutResponse() {
    return {
        total: BigInt(0),
        details: []
    };
}
export const QueryProviderMonthlyPayoutResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryProviderMonthlyPayoutResponse",
    is(o) {
        return o && (o.$typeUrl === QueryProviderMonthlyPayoutResponse.typeUrl || typeof o.total === "bigint" && Array.isArray(o.details) && (!o.details.length || SubscriptionPayout.is(o.details[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProviderMonthlyPayoutResponse.typeUrl || typeof o.total === "bigint" && Array.isArray(o.details) && (!o.details.length || SubscriptionPayout.isSDK(o.details[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProviderMonthlyPayoutResponse.typeUrl || typeof o.total === "bigint" && Array.isArray(o.details) && (!o.details.length || SubscriptionPayout.isAmino(o.details[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.total !== BigInt(0)) {
            writer.uint32(8).uint64(message.total);
        }
        for (const v of message.details) {
            SubscriptionPayout.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProviderMonthlyPayoutResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.total = reader.uint64();
                    break;
                case 2:
                    message.details.push(SubscriptionPayout.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            total: isSet(object.total) ? BigInt(object.total.toString()) : BigInt(0),
            details: Array.isArray(object?.details) ? object.details.map((e) => SubscriptionPayout.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.total !== undefined && (obj.total = (message.total || BigInt(0)).toString());
        if (message.details) {
            obj.details = message.details.map(e => e ? SubscriptionPayout.toJSON(e) : undefined);
        }
        else {
            obj.details = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProviderMonthlyPayoutResponse();
        message.total = object.total !== undefined && object.total !== null ? BigInt(object.total.toString()) : BigInt(0);
        message.details = object.details?.map(e => SubscriptionPayout.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProviderMonthlyPayoutResponse();
        if (object.total !== undefined && object.total !== null) {
            message.total = BigInt(object.total);
        }
        message.details = object.details?.map(e => SubscriptionPayout.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.total = message.total !== BigInt(0) ? (message.total?.toString)() : undefined;
        if (message.details) {
            obj.details = message.details.map(e => e ? SubscriptionPayout.toAmino(e) : undefined);
        }
        else {
            obj.details = message.details;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProviderMonthlyPayoutResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProviderMonthlyPayoutResponse.decode(message.value);
    },
    toProto(message) {
        return QueryProviderMonthlyPayoutResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryProviderMonthlyPayoutResponse",
            value: QueryProviderMonthlyPayoutResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProviderMonthlyPayoutResponse.typeUrl, QueryProviderMonthlyPayoutResponse);
function createBaseProviderPayout() {
    return {
        provider: "",
        amount: BigInt(0)
    };
}
export const ProviderPayout = {
    typeUrl: "/lavanet.lava.pairing.ProviderPayout",
    is(o) {
        return o && (o.$typeUrl === ProviderPayout.typeUrl || typeof o.provider === "string" && typeof o.amount === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === ProviderPayout.typeUrl || typeof o.provider === "string" && typeof o.amount === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === ProviderPayout.typeUrl || typeof o.provider === "string" && typeof o.amount === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.provider !== "") {
            writer.uint32(10).string(message.provider);
        }
        if (message.amount !== BigInt(0)) {
            writer.uint32(16).uint64(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProviderPayout();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.provider = reader.string();
                    break;
                case 2:
                    message.amount = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            provider: isSet(object.provider) ? String(object.provider) : "",
            amount: isSet(object.amount) ? BigInt(object.amount.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.provider !== undefined && (obj.provider = message.provider);
        message.amount !== undefined && (obj.amount = (message.amount || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseProviderPayout();
        message.provider = object.provider ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? BigInt(object.amount.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseProviderPayout();
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = BigInt(object.amount);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.provider = message.provider === "" ? undefined : message.provider;
        obj.amount = message.amount !== BigInt(0) ? (message.amount?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return ProviderPayout.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return ProviderPayout.decode(message.value);
    },
    toProto(message) {
        return ProviderPayout.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.ProviderPayout",
            value: ProviderPayout.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(ProviderPayout.typeUrl, ProviderPayout);
function createBaseChainIDPayout() {
    return {
        chainId: "",
        payouts: []
    };
}
export const ChainIDPayout = {
    typeUrl: "/lavanet.lava.pairing.ChainIDPayout",
    is(o) {
        return o && (o.$typeUrl === ChainIDPayout.typeUrl || typeof o.chainId === "string" && Array.isArray(o.payouts) && (!o.payouts.length || ProviderPayout.is(o.payouts[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === ChainIDPayout.typeUrl || typeof o.chain_id === "string" && Array.isArray(o.payouts) && (!o.payouts.length || ProviderPayout.isSDK(o.payouts[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === ChainIDPayout.typeUrl || typeof o.chain_id === "string" && Array.isArray(o.payouts) && (!o.payouts.length || ProviderPayout.isAmino(o.payouts[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        for (const v of message.payouts) {
            ProviderPayout.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChainIDPayout();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.payouts.push(ProviderPayout.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainId: isSet(object.chainId) ? String(object.chainId) : "",
            payouts: Array.isArray(object?.payouts) ? object.payouts.map((e) => ProviderPayout.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        if (message.payouts) {
            obj.payouts = message.payouts.map(e => e ? ProviderPayout.toJSON(e) : undefined);
        }
        else {
            obj.payouts = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseChainIDPayout();
        message.chainId = object.chainId ?? "";
        message.payouts = object.payouts?.map(e => ProviderPayout.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseChainIDPayout();
        if (object.chain_id !== undefined && object.chain_id !== null) {
            message.chainId = object.chain_id;
        }
        message.payouts = object.payouts?.map(e => ProviderPayout.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.chain_id = message.chainId === "" ? undefined : message.chainId;
        if (message.payouts) {
            obj.payouts = message.payouts.map(e => e ? ProviderPayout.toAmino(e) : undefined);
        }
        else {
            obj.payouts = message.payouts;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return ChainIDPayout.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return ChainIDPayout.decode(message.value);
    },
    toProto(message) {
        return ChainIDPayout.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.ChainIDPayout",
            value: ChainIDPayout.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(ChainIDPayout.typeUrl, ChainIDPayout);
function createBaseQuerySubscriptionMonthlyPayoutRequest() {
    return {
        consumer: ""
    };
}
export const QuerySubscriptionMonthlyPayoutRequest = {
    typeUrl: "/lavanet.lava.pairing.QuerySubscriptionMonthlyPayoutRequest",
    is(o) {
        return o && (o.$typeUrl === QuerySubscriptionMonthlyPayoutRequest.typeUrl || typeof o.consumer === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QuerySubscriptionMonthlyPayoutRequest.typeUrl || typeof o.consumer === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QuerySubscriptionMonthlyPayoutRequest.typeUrl || typeof o.consumer === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.consumer !== "") {
            writer.uint32(10).string(message.consumer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySubscriptionMonthlyPayoutRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consumer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consumer: isSet(object.consumer) ? String(object.consumer) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.consumer !== undefined && (obj.consumer = message.consumer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySubscriptionMonthlyPayoutRequest();
        message.consumer = object.consumer ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQuerySubscriptionMonthlyPayoutRequest();
        if (object.consumer !== undefined && object.consumer !== null) {
            message.consumer = object.consumer;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.consumer = message.consumer === "" ? undefined : message.consumer;
        return obj;
    },
    fromAminoMsg(object) {
        return QuerySubscriptionMonthlyPayoutRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QuerySubscriptionMonthlyPayoutRequest.decode(message.value);
    },
    toProto(message) {
        return QuerySubscriptionMonthlyPayoutRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QuerySubscriptionMonthlyPayoutRequest",
            value: QuerySubscriptionMonthlyPayoutRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QuerySubscriptionMonthlyPayoutRequest.typeUrl, QuerySubscriptionMonthlyPayoutRequest);
function createBaseQuerySubscriptionMonthlyPayoutResponse() {
    return {
        total: BigInt(0),
        details: []
    };
}
export const QuerySubscriptionMonthlyPayoutResponse = {
    typeUrl: "/lavanet.lava.pairing.QuerySubscriptionMonthlyPayoutResponse",
    is(o) {
        return o && (o.$typeUrl === QuerySubscriptionMonthlyPayoutResponse.typeUrl || typeof o.total === "bigint" && Array.isArray(o.details) && (!o.details.length || ChainIDPayout.is(o.details[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QuerySubscriptionMonthlyPayoutResponse.typeUrl || typeof o.total === "bigint" && Array.isArray(o.details) && (!o.details.length || ChainIDPayout.isSDK(o.details[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QuerySubscriptionMonthlyPayoutResponse.typeUrl || typeof o.total === "bigint" && Array.isArray(o.details) && (!o.details.length || ChainIDPayout.isAmino(o.details[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.total !== BigInt(0)) {
            writer.uint32(8).uint64(message.total);
        }
        for (const v of message.details) {
            ChainIDPayout.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySubscriptionMonthlyPayoutResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.total = reader.uint64();
                    break;
                case 2:
                    message.details.push(ChainIDPayout.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            total: isSet(object.total) ? BigInt(object.total.toString()) : BigInt(0),
            details: Array.isArray(object?.details) ? object.details.map((e) => ChainIDPayout.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.total !== undefined && (obj.total = (message.total || BigInt(0)).toString());
        if (message.details) {
            obj.details = message.details.map(e => e ? ChainIDPayout.toJSON(e) : undefined);
        }
        else {
            obj.details = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySubscriptionMonthlyPayoutResponse();
        message.total = object.total !== undefined && object.total !== null ? BigInt(object.total.toString()) : BigInt(0);
        message.details = object.details?.map(e => ChainIDPayout.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQuerySubscriptionMonthlyPayoutResponse();
        if (object.total !== undefined && object.total !== null) {
            message.total = BigInt(object.total);
        }
        message.details = object.details?.map(e => ChainIDPayout.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.total = message.total !== BigInt(0) ? (message.total?.toString)() : undefined;
        if (message.details) {
            obj.details = message.details.map(e => e ? ChainIDPayout.toAmino(e) : undefined);
        }
        else {
            obj.details = message.details;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QuerySubscriptionMonthlyPayoutResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QuerySubscriptionMonthlyPayoutResponse.decode(message.value);
    },
    toProto(message) {
        return QuerySubscriptionMonthlyPayoutResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QuerySubscriptionMonthlyPayoutResponse",
            value: QuerySubscriptionMonthlyPayoutResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QuerySubscriptionMonthlyPayoutResponse.typeUrl, QuerySubscriptionMonthlyPayoutResponse);
function createBaseQueryProvidersEpochCuRequest() {
    return {};
}
export const QueryProvidersEpochCuRequest = {
    typeUrl: "/lavanet.lava.pairing.QueryProvidersEpochCuRequest",
    is(o) {
        return o && o.$typeUrl === QueryProvidersEpochCuRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryProvidersEpochCuRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryProvidersEpochCuRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProvidersEpochCuRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryProvidersEpochCuRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryProvidersEpochCuRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProvidersEpochCuRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProvidersEpochCuRequest.decode(message.value);
    },
    toProto(message) {
        return QueryProvidersEpochCuRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryProvidersEpochCuRequest",
            value: QueryProvidersEpochCuRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProvidersEpochCuRequest.typeUrl, QueryProvidersEpochCuRequest);
function createBaseQueryProvidersEpochCuResponse() {
    return {
        info: []
    };
}
export const QueryProvidersEpochCuResponse = {
    typeUrl: "/lavanet.lava.pairing.QueryProvidersEpochCuResponse",
    is(o) {
        return o && (o.$typeUrl === QueryProvidersEpochCuResponse.typeUrl || Array.isArray(o.info) && (!o.info.length || ProviderCuInfo.is(o.info[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProvidersEpochCuResponse.typeUrl || Array.isArray(o.info) && (!o.info.length || ProviderCuInfo.isSDK(o.info[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProvidersEpochCuResponse.typeUrl || Array.isArray(o.info) && (!o.info.length || ProviderCuInfo.isAmino(o.info[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.info) {
            ProviderCuInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProvidersEpochCuResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.info.push(ProviderCuInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            info: Array.isArray(object?.info) ? object.info.map((e) => ProviderCuInfo.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.info) {
            obj.info = message.info.map(e => e ? ProviderCuInfo.toJSON(e) : undefined);
        }
        else {
            obj.info = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProvidersEpochCuResponse();
        message.info = object.info?.map(e => ProviderCuInfo.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProvidersEpochCuResponse();
        message.info = object.info?.map(e => ProviderCuInfo.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.info) {
            obj.info = message.info.map(e => e ? ProviderCuInfo.toAmino(e) : undefined);
        }
        else {
            obj.info = message.info;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProvidersEpochCuResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProvidersEpochCuResponse.decode(message.value);
    },
    toProto(message) {
        return QueryProvidersEpochCuResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.QueryProvidersEpochCuResponse",
            value: QueryProvidersEpochCuResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProvidersEpochCuResponse.typeUrl, QueryProvidersEpochCuResponse);
function createBaseProviderCuInfo() {
    return {
        provider: "",
        cu: BigInt(0)
    };
}
export const ProviderCuInfo = {
    typeUrl: "/lavanet.lava.pairing.ProviderCuInfo",
    is(o) {
        return o && (o.$typeUrl === ProviderCuInfo.typeUrl || typeof o.provider === "string" && typeof o.cu === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === ProviderCuInfo.typeUrl || typeof o.provider === "string" && typeof o.cu === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === ProviderCuInfo.typeUrl || typeof o.provider === "string" && typeof o.cu === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.provider !== "") {
            writer.uint32(10).string(message.provider);
        }
        if (message.cu !== BigInt(0)) {
            writer.uint32(16).uint64(message.cu);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProviderCuInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.provider = reader.string();
                    break;
                case 2:
                    message.cu = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            provider: isSet(object.provider) ? String(object.provider) : "",
            cu: isSet(object.cu) ? BigInt(object.cu.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.provider !== undefined && (obj.provider = message.provider);
        message.cu !== undefined && (obj.cu = (message.cu || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseProviderCuInfo();
        message.provider = object.provider ?? "";
        message.cu = object.cu !== undefined && object.cu !== null ? BigInt(object.cu.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseProviderCuInfo();
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        if (object.cu !== undefined && object.cu !== null) {
            message.cu = BigInt(object.cu);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.provider = message.provider === "" ? undefined : message.provider;
        obj.cu = message.cu !== BigInt(0) ? (message.cu?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return ProviderCuInfo.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return ProviderCuInfo.decode(message.value);
    },
    toProto(message) {
        return ProviderCuInfo.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.pairing.ProviderCuInfo",
            value: ProviderCuInfo.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(ProviderCuInfo.typeUrl, ProviderCuInfo);
